(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("CampaignController", CampaignController);

    function CampaignController(
        $state,
        $q,
        $translate,
        Principal,
        toastr,
        CampaignService,
        UserService,
        StoreInfoFactory,
        moment,
        $scope,
        $stateParams,
        $uibModal,
        $localStorage
    ) {
        var vm = this;

        var CREATED_FROM_MAP = {
            HUB: "HUB",
            STORE: "STORE",
        };

        var SCHEDULE_OPTIONS_MAP = {
            WHEN_ACTIVATE: 'WHEN_ACTIVATE',
            CHOICE_DATE: 'CHOICE_DATE',
            INDETERMINATE: 'INDETERMINATE'
        };

        vm.types = [
            {
                label: "campaign.new.type.whatsapp",
                value: "WHATSAPP",
                subtitle: "campaign.new.type.whatsapp-subtitle",
                iconClass: "fa fa-phone",
            },
        ];

        vm.startDateChoices = [
            {
                label: "campaign.new.schedule.start-date.options.when-activate.title",
                value: SCHEDULE_OPTIONS_MAP.WHEN_ACTIVATE,
                subtitle:
                    "campaign.new.schedule.start-date.options.when-activate.subtitle",
                showChildrenElement: false
            },
            {
                label: "campaign.new.schedule.start-date.options.choice-date.title",
                value: SCHEDULE_OPTIONS_MAP.CHOICE_DATE,
                subtitle:
                    "campaign.new.schedule.start-date.options.choice-date.subtitle",
                showChildrenElement: true
            },
        ];

        vm.expirationDateChoices = [
            {
                label: "campaign.new.schedule.expiration-date.options.indeterminate.title",
                value: SCHEDULE_OPTIONS_MAP.INDETERMINATE,
                subtitle:
                    "campaign.new.schedule.expiration-date.options.indeterminate.subtitle",
                showChildrenElement: false
            },
            {
                label: "campaign.new.schedule.expiration-date.options.choice-date.title",
                value: SCHEDULE_OPTIONS_MAP.CHOICE_DATE,
                subtitle:
                    "campaign.new.schedule.expiration-date.options.choice-date.subtitle",
                showChildrenElement: true
            },
        ];

        vm.contentMaxLength = 4096;

        vm.errorMessages = {
            required: "entity.validation.required",
            minlength: "entity.validation.minlength",
            maxlength: "entity.validation.maxlength",
        };

        vm.account = undefined;
        vm.userProfile = undefined;

        vm.isLoading = false;
        vm.submitLoading = false;
        const DATE_FORMAT = $translate.instant('momentDateFormat');
        vm.today = moment().format(DATE_FORMAT);

        vm.storeId = StoreInfoFactory.getStoreId();
        vm.bannerImageURL = "https://showkase-prod.s3.sa-east-1.amazonaws.com/assets/public-banner-image.svg";

        vm.campaign = {
            type: "WHATSAPP",
            activationDateChoice: SCHEDULE_OPTIONS_MAP.WHEN_ACTIVATE,
            expirationDateChoice: SCHEDULE_OPTIONS_MAP.INDETERMINATE,
            distributionMethod: "AUTOMATIC",
            balancedDistribution: true,
            limitSellerCapacity: false,
            prioritizeSellerClients: false,
        };

        vm.campaignSellerLimit = null;
        vm.hasGlobalSellerLimit = false;

        vm.distributionMethods = [
            {
                label: "campaign.new.distribution-method.automatic.title",
                value: "AUTOMATIC",
                subtitle: "campaign.new.distribution-method.automatic.subtitle",
                iconClass: "icon-ksc-user-solid",
                showChildrenElement: true,
            },
            {
                label: "campaign.new.distribution-method.manual.title",
                value: "MANUAL",
                subtitle: "campaign.new.distribution-method.manual.subtitle",
                iconClass: "fa fa-hand-pointer-o",
                showChildrenElement: false,
            },
        ];

        vm.onChangeBalancedDistribution = function () {
            if (!vm.campaign.balancedDistribution) {
                vm.campaign.limitSellerCapacity = false;
            }
        };

        vm.showError = false;

        vm.isDuplicateCampaign = $state.current.url.includes("duplicate");
        vm.campaignId = $stateParams.id;

        vm.activateRecurrence = false;
        vm.targetAudience = null;

        vm.recurrenceOptions = [
            {
                name: $translate.instant("campaign.new.schedule.recurrence.select.options.daily"),
                value: "DAILY"
            },
            {
                name: $translate.instant("campaign.new.schedule.recurrence.select.options.weekly"),
                value: "WEEKLY"
            },
            {
                name: $translate.instant("campaign.new.schedule.recurrence.select.options.monthly"),
                value: "MONTHLY"
            },
            {
                name: $translate.instant("campaign.new.schedule.recurrence.select.options.annual"),
                value: "ANNUAL"
            },
        ];

        vm.selectedUsers = getSelectAllPaginatedModel();

        vm.listUsersFilterOptions = UserService.getUsersSellersByStore;

        vm.hasCampaignDistribution = false;

        vm.init = init();

        function init() {
            vm.isHubContext = $localStorage.defaultStore.hubContext;
            Principal.identity().then(function (account) {
                if (account) {
                    vm.account = angular.copy(account);
                    vm.userProfile = vm.account.userProfiles[0];
                    vm.campaign.createdFrom = vm.account.isHubAdmin
                        ? CREATED_FROM_MAP.HUB
                        : CREATED_FROM_MAP.STORE;
                }
            });

            if (!vm.isHubContext) {
                vm.dynamicFilterOptions = {
                    users: getDynamicFilterOptionsModel(true)
                }
            }

            CampaignService.getCampaignSettings().then(function (res) {
                vm.campaignSellerLimit = res.campaignSellerLimit;
                vm.hasGlobalSellerLimit = res.campaignSellerLimit !== null && res.campaignSellerLimit !== undefined;
            });

            if (vm.campaignId) {
                CampaignService.get(vm.campaignId).then(function (result) {
                    vm.campaign = result.data.campaign;
                    vm.campaign.createdFrom = vm.account.isHubAdmin
                        ? CREATED_FROM_MAP.HUB
                        : CREATED_FROM_MAP.STORE;
                    if (vm.campaign.endDate) {
                        vm.campaign.endDate = moment(
                            vm.campaign.endDate
                        ).format(DATE_FORMAT);
                    }

                    if (vm.campaign.startDate) {
                        vm.campaign.startDate = moment(
                            vm.campaign.startDate
                        ).format(DATE_FORMAT);
                    }

                    if (vm.campaign.activationDate) {
                        vm.campaign.activationDateChoice = SCHEDULE_OPTIONS_MAP.CHOICE_DATE
                        vm.campaign.activationDate = moment(vm.campaign.activationDate).format(DATE_FORMAT);
                    } else {
                        vm.campaign.activationDateChoice = SCHEDULE_OPTIONS_MAP.WHEN_ACTIVATE
                    }
                    if (vm.campaign.expirationDate) {
                        vm.campaign.expirationDateChoice = SCHEDULE_OPTIONS_MAP.CHOICE_DATE;
                        vm.campaign.expirationDate = moment(vm.campaign.expirationDate).format(DATE_FORMAT);
                    } else {
                        vm.campaign.expirationDateChoice = SCHEDULE_OPTIONS_MAP.INDETERMINATE;
                    }

                    if (vm.campaign.expirationDate) {
                        if (moment().isAfter(vm.campaign.expirationDate)) {
                            vm.campaign.expirationDate = null;
                            vm.campaign.expirationDateChoice = SCHEDULE_OPTIONS_MAP.INDETERMINATE;
                        }
                    }

                    if (vm.campaign.activationDate) {
                        if (moment().isAfter(vm.campaign.activationDate)) {
                            vm.campaign.activationDate = null;
                            vm.campaign.activationDateChoice = SCHEDULE_OPTIONS_MAP.WHEN_ACTIVATE;
                        }
                    }

                    if (vm.campaign.sellerSelection) {
                        vm.hasCampaignDistribution = true;
                        vm.selectedUsers = vm.campaign.sellerSelection;
                    }

                    vm.campaign.distributionMethod = vm.campaign.automaticDistribution ? "AUTOMATIC" : "MANUAL";
                    vm.campaign.balancedDistribution = !!vm.campaign.balancedDistribution;
                    vm.campaign.limitSellerCapacity = !!vm.campaign.limitSellerCapacity;
                    vm.campaign.prioritizeSellerClients = !!vm.campaign.prioritizeSellerClients;

                    if (vm.campaign.targetAudienceId) {
                        vm.targetAudience = {
                            value: vm.campaign.targetAudience.id,
                            label: vm.campaign.targetAudience.name
                        };
                    }
                });
            }
        }

        vm.save = function save() {
            if (vm.submitLoading) return;
            vm.submitLoading = true;
            vm.showError = false;
            vm.campaign.sellerSelection = vm.selectedUsers;
            var data = angular.copy(vm.campaign);
            if (data.startDate) {
                data.startDate = moment(data.startDate, DATE_FORMAT).format('YYYY-MM-DD');
            }
            if (data.endDate) {
                data.endDate = moment(data.endDate, DATE_FORMAT).format('YYYY-MM-DD');
            }
            if (data.expirationDate) {
                data.expirationDate = moment(
                    data.expirationDate,
                    DATE_FORMAT
                ).format('YYYY-MM-DD');
            }
            if (data.activationDate) {
                data.activationDate = moment(
                    data.activationDate,
                    DATE_FORMAT
                ).format('YYYY-MM-DD');
            }
            delete data.activationDateChoice;
            delete data.expirationDateChoice;
            delete data.activateRecurrence;

            data.automaticDistribution = vm.campaign.distributionMethod === 'AUTOMATIC';
            if (!data.automaticDistribution) {
                data.balancedDistribution = false;
                data.limitSellerCapacity = false;
                data.prioritizeSellerClients = false;
            } else {
                if (!data.balancedDistribution) {
                    data.limitSellerCapacity = false;
                }
                if (!vm.hasGlobalSellerLimit) {
                    data.limitSellerCapacity = false;
                }
            }
            delete data.distributionMethod;

            data.targetAudienceId = vm.targetAudience.value;

            CampaignService.createCampaign(data).then(
                function () {
                    vm.submitLoading = false;
                    toastr.success(
                        $translate.instant("campaign.messages.success")
                    );
                    $state.go("campaign");
                },
                function (error) {
                    vm.submitLoading = false;
                    toastr.error($translate.instant("campaign.messages.error.create"));
                }
            );
        };

        vm.targetAudiencesActions = [
            {
                icon: 'fa fa-trash',
                label: 'campaign.new.public-info.actions.remove',
                method: function () {
                    vm.openConfirmRemovalModal();
                }
            },
            {
                icon: 'fa fa-eye',
                label: 'campaign.new.public-info.actions.view',
                method: function (item) {
                    vm.actionItemValue = item.value;
                    vm.openViewTargetAudienceMenu();
                }
            }
        ];

        vm.back = function () {
            $state.go("campaign");
        };

        vm.openConfirmRemovalModal = function () {
            return $uibModal.open({
                templateUrl: 'app/components/modal/action-confirmation-modal/action-confirmation-modal.html',
                controller: 'ActionConfirmationModalController',
                controllerAs: 'vm',
                windowClass: 'modal-center confirmation-modal',
                windowTopClass: 'center-modal',
                backdrop: 'static',
                resolve: {
                    modalImage: function () {
                        return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/assets/remove-public-modal-image.svg'
                    },
                    modalTitle: function () {
                        return 'campaign.new.public-info.modal.remove.title'
                    },
                    modalDescription: function () {
                        return 'campaign.new.public-info.modal.remove.description'
                    },
                    buttonStyle: function () {
                        return 'ERROR'
                    }

                }
            }).result.then(function (confirm) {
                if (confirm) vm.targetAudience = null;
            });
        };

        vm.openListOfTargetAudienceMenu = function () {
            return $uibModal.open({
                templateUrl: 'app/admin/campaign/target-audience/list-target-audience/list-target-audience.html',
                controller: 'ListTargetAudienceController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal',
                backdrop: 'static',
                resolve: {
                    selectedTarget: function () {
                        return vm.targetAudience;
                    }
                }
            }).result.then(function (result) {
                if (result.currentDeleted && !result.selectedItem) {
                    vm.targetAudience = null;
                    return;
                }

                if (!result.selectedItem) return;
                vm.targetAudience = result.selectedItem;
            });
        };

        vm.openViewTargetAudienceMenu = function () {
            return $uibModal.open({
                templateUrl: 'app/admin/campaign/target-audience/create-target-audience/create-target-audience.html',
                controller: 'CreateTargetAudienceController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal full-screen-modal',
                backdrop: 'static',
                resolve: {

                    targetAudienceId: function () {
                        return vm.actionItemValue;
                    },
                    isViewMode: function () {
                        return true;
                    }
                }
            }).result.then(function (createdItem) {
                vm.reOpenListOfTargetAudienceMenu();
            });
        };

        vm.openCreateTargetAudienceMenu = function () {
            return $uibModal.open({
                templateUrl: 'app/admin/campaign/target-audience/create-target-audience/create-target-audience.html',
                controller: 'CreateTargetAudienceController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal full-screen-modal',
                backdrop: 'static',
                resolve: {
                    targetAudienceId: function () {
                        return null;
                    },
                    isViewMode: function () {
                        return false;
                    }
                }
            }).result.then(function (createdItem) {
                if (!createdItem) return
                vm.targetAudience = createdItem;
            });
        };

        vm.changeActivationDateChoice = function () {
            if (vm.campaign.activationDateChoice !== SCHEDULE_OPTIONS_MAP.CHOICE_DATE) {
                vm.campaign.activationDate = undefined;
                if (vm.campaignForm.activationDate && Object.keys(vm.campaignForm.activationDate.$error).length > 0) {
                    vm.campaignForm.activationDate.$setPristine(false);
                    vm.campaignForm.activationDate.$setUntouched();
                }
            }

            if (vm.campaign.expirationDateChoice === SCHEDULE_OPTIONS_MAP.CHOICE_DATE) {
                vm.expirationDateOptions = {
                    format: DATE_FORMAT,
                    sideBySide: true,
                    ignoreReadonly: true,
                    minDate: vm.campaign.activationDate
                        ? moment(vm.campaign.activationDate, DATE_FORMAT).add(1, 'days')
                        : moment(),
                    locale: moment.locale(),
                    allowInputToggle: true,
                    useCurrent: false,
                };
            } else {
                vm.campaign.expirationDate = undefined;
                if (vm.campaignForm.expirationDate && Object.keys(vm.campaignForm.expirationDate.$error).length > 0) {
                    vm.campaignForm.expirationDate.$setPristine(false);
                    vm.campaignForm.expirationDate.$setUntouched();
                }
            }
        };

        vm.changeRecurrenceToggle = function () {
            if (!vm.activateRecurrence) {
                vm.campaign.recurrence = null;
            }
        };
    }
})();
